import { combineReducers } from 'redux';
// eslint-disable-next-line import/no-cycle
import { api } from './auth/apiSlice';
// eslint-disable-next-line import/no-cycle
import { cashApi } from '../components/template/SideNav/sideNavSlice';
import theme from './theme/themeSlice';
import auth from './auth/authSlice';
import base from './base';
import { locationApi, gamilApi } from '../view/dashboard/store/dashboardSlice';

interface RootReducerI {
  asyncReducers?: any;
}

const rootReducer =
  (asyncReducers?: RootReducerI) => (state: any, action: any) => {
    const combinedReducer = combineReducers({
      [api.reducerPath]: api.reducer,
      [cashApi.reducerPath]: cashApi.reducer,
      [locationApi.reducerPath]: locationApi.reducer,
      [gamilApi.reducerPath]: gamilApi.reducer,
      auth,
      base,
      theme,
      ...asyncReducers,
    });
    return combinedReducer(state, action);
  };

export default rootReducer;

// import { configureStore } from '@reduxjs/toolkit';
// import counterReducer from '../counterSlice';

// export const store = configureStore({
//   reducer: {
//     counter: counterReducer,
//   },
// });

// // Infer the `RootState` and `AppDispatch` types from the store itself
// export type RootState = ReturnType<typeof store.getState>;
// // Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
// export type AppDispatch = typeof store.dispatch;
